import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'fair',
        title: 'Fair',
        translate: 'NAV.FAIR',
        type: 'group',
        children: [
            {
                id: 'home',
                title:  $localize`home`,
                type: 'item',
                icon: 'core:home',
                url: '/online-fair',
                badge   : {
                    title: '12',
                    bg       : '#EC0C8E',
                    fg       : '#FFFFFF'
                }
            }, {
                id: 'news',
                title: $localize`news`,
                type: 'item',
                icon: 'core:home',
                url: '/news'
            }]
    },
    {
        id: 'administration',
        title: 'Administration',
        translate: 'NAV.ADMINISTRATION',
        type: 'group',
        icon: 'core:lock',
        roles: ['admin'],
        children: [
            {
                id: 'user-manager',
                title: 'Users Manager',
                translate: 'NAV.USERS_MANAGER',
                type: 'item',
                icon: 'core:people',
                url: '/login',
                roles: ['admin'],
                skipRouteLocalization: true
            },
            {
                id: 'companies-manager',
                title: 'Companies Manager',
                translate: 'NAV.COMPANIES_MANAGER',
                type: 'item',
                icon: 'core:check_box',
                url: '/administration/companies/all',
                roles: ['admin'],
                skipRouteLocalization: true
            }
        ]
    }
];
